import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const WaybillDetail = React.lazy(() => import('../components/WaybillDetail'));
function WaybillDetailView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <WaybillDetail {...props} />
    </Suspense>
  );
}

export default WaybillDetailView;
